module.exports = __webpack_public_path__ + "static/media/journey_sl_init.bb0db86d.png";